import MainAddress from "../";
import { GetSerialProgram } from "../../util/sessionManager";
import { GetWithExpiry } from "../../util/sessionManager";
import axios from 'axios';
export async function getAllRequests(){


    try{
        const response = await axios.post(
            MainAddress+"Request/read_reaquestHistory.php",
            {
                serial_program:GetSerialProgram(),
            }
          )
    
        if(response.data[0].success ){
            return {
                success:true,
                data:response.data
            }
        }else{
            return {
                success:false,
                message:response
            };
        }
    }catch(error){
        return {
            success:false,
            message:error
        };
    }

}
export async function getRequestsDetails(data){


    try{
        const response = await axios.post(
            MainAddress+"Request/read_invoiceDetails.php",
            {
                serial_program:GetSerialProgram(),
                ...data
            }
          )
    
        if(response.data[0].success ){
            return {
                success:true,
                data:response.data
            }
        }else{
            return {
                success:false,
                message:response
            };
        }
    }catch(error){
        return {
            success:false,
            message:error
        };
    }

}